import { api } from '../../DefaultService';
import { IStudentFilterProps } from '../../StudentService/types';
import { IPaginationParams, ISelectionOption } from '../../types';
import {
  IStudentRecognitionCreateProps,
  IStudentRecognitionProps,
  IStudentRecognitionSimpleProps,
  IStudentRecognitionUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/student';

export const createStudentRecognitionAsync = async (
  data: IStudentRecognitionCreateProps,
): Promise<IStudentRecognitionProps> => {
  return await api
    .post(`${ENDPOINT}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const updateStudentRecognitionAsync = async ({
  id,
  data,
}: IStudentRecognitionUpdateParams): Promise<IStudentRecognitionProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getStudentRecognitionByIdAsync = async (
  id: number,
): Promise<IStudentRecognitionProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getAllStudentsByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IStudentFilterProps,
): Promise<IStudentRecognitionSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getAllStudentsForSelectionAsync = async (): Promise<ISelectionOption[]> => {
  try {
    const response = await api.get(`${ENDPOINT}/selection`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar lista de estudantes.');
  }
};
